export const LOG_KEY = 'mini-shopping-bag';
export const LOG_QUANTITY_PICKER = 'mini-shopping-bag-quantity-picker';

export const log = <Args extends readonly unknown[]>(...args: Args) => {
  const isLoggerOn = Boolean(JSON.parse(localStorage.getItem(`${LOG_KEY} debug`) ?? '0'));
  if (!isLoggerOn) {
    return;
  }

  const date = new Date();
  const formattedMinutes = `0${date.getMinutes()}`.slice(-2);
  const formattedSeconds = `0${date.getSeconds()}`.slice(-2);
  const formattedMilliSeconds = `00${date.getMilliseconds()}`.slice(-3);
  const time = `${date.getHours()}:${formattedMinutes}:${formattedSeconds}.${formattedMilliSeconds}`;
  // eslint-disable-next-line no-console -- simple logger
  console.log(`%c${time} %c${LOG_KEY}:`, 'color: #09c', 'color: #c90;', ...args);
};

export const logQuantityPicker = <Args extends readonly unknown[]>(...args: Args) =>
  log(LOG_QUANTITY_PICKER, ...args);
